const LocalStoragekeys = {
    Access_Token: "@k1-A-T",
    FCM_Token: "@k2-F-T",
   
    User_Name: "@k4-U-N",
    Seen_Intro: "@k5-S-I",
    Pins: "@k6-P",
    Regions: "@k7-R",
    ProvinceSelection: "@k8-P-S",
    LocationPermission: "@k9-L-P",
    TaxiPaymentCashbackModalShown: "@k10-T-P-C-M-S",
    NewVersionFeaturesModalShown: "@k11-N-V-F-M-S",
    AcceptShakeMobile: "@k12-A-S-M",
    PhoneSearchParams: "@k13-P-S-P",
    c: "@k14"
};
export default LocalStoragekeys;